import React, { FC } from 'react'
import './BackButton.scss'

type BackButtonProps = {
  iconColor?: string
  color?: string
} & JSX.IntrinsicElements['button']

const BackButton: FC<BackButtonProps> = (props) => {
  if (props.onClick) {
    return (
      <button data-testing='back-button' className='font-lightgray back-button link-text' onClick={props.onClick}>
        <i
          className='back-icon is24-icon-arrow-left align-middle padding-right-s font-xl'
          style={{ color: props.color }}
        />
        <span className='palm-hide' style={{ color: props.color }}>
          Zurück
        </span>
      </button>
    )
  }
  return <div className='push-text' data-testid='back-button-placeholder' />
}

export default BackButton
